import React from "react";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import ProductCard from "./ProductCard";
import { PRODUCTS } from "../data/data";
import { useCart } from "../context/CartContext";

export function FeaturedProducts() {
  const { addToCart } = useCart();
  return (
    <section id="shop" className="py-24 px-6 md:px-10" style={{ background: "#12161F" }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
                This Week
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl">Featured pieces</h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <a href="/" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest border-b pb-1" style={{ borderColor: "#1E9AFF" }}>
              View all products <ArrowRight size={14} />
            </a>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.name} p={p} index={i} onAdd={addToCart} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedProducts;
